export class OfferContractPaymentType {
  id: number;
  displayName: string;
}
